import React, { useState, useEffect, useMemo } from "react";
// import { LoginAdmin } from "../../pages/Admin";
// import { ModalBasic } from "../../components/Common";
// import { useAuth } from "../../hooks";
// import { TopMenu, SideMenu } from "../../components/Admin";
import {  SideMenu } from "../Menu/SideMenu";
import {  TopMenu } from "../Menu/TopMenu";
import "./AdminLayout.scss";

export function AdminLayout(props) {
  const { children } = props;
  // const { auth, compruebaAutenticacion } = useAuth();
  const [collapsedMenuAnt, setCollapsedMenuAnt] = useState(false);

  // if (!auth) return <LoginAdmin />;

  return (
    <div className="admin-layout">
      <div className="admin-Layout__menu">
        <TopMenu setCollapsedMenuAnt={setCollapsedMenuAnt} collapsedMenuAnt={collapsedMenuAnt} />
      </div>

      <div className="admin-layout__main-content">
        <SideMenu collapsedMenuAnt={collapsedMenuAnt}>{children}</SideMenu>
      </div>
    </div>
  );
}